import { allModelsSelector } from 'common-src/utils/selectorUtils';

export const getPatientIntegrationsZus = (state, patientId) =>
  allModelsSelector(
    state,
    'PatientIntegrationsZus',
    (integration) => integration.patientId === patientId,
  ).sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
